import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminPanel from './pages/admin-panel';
import PortfolioDashboard from './pages/portfolio-dashboard';
import InventoryManagement from './pages/inventory-management';
import LoginPage from './pages/login';
import AccountSettings from './pages/account-settings';
import CraneSearchDashboard from './pages/crane-search-dashboard';
import CraneValuationReport from './pages/crane-valuation-report';
import ComparisonTool from './pages/comparison-tool';
import Register from './pages/register';
import CustomCraneValuation from './pages/custom-crane-valuation';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<CraneSearchDashboard />} />
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/portfolio-dashboard" element={<PortfolioDashboard />} />
        <Route path="/inventory-management" element={<InventoryManagement />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/account-settings" element={<AccountSettings />} />
        <Route path="/crane-search-dashboard" element={<CraneSearchDashboard />} />
        <Route path="/crane-valuation-report" element={<CraneValuationReport />} />
        <Route path="/comparison-tool" element={<ComparisonTool />} />
        <Route path="/register" element={<Register />} />
        <Route path="/custom-crane-valuation" element={<CustomCraneValuation />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;